import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  buque: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  playa: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  pendiente: { value: null, matchMode: FilterMatchMode.CONTAINS },
  estadoVGM: { value: null, matchMode: FilterMatchMode.CONTAINS },
  cierreStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  statusout: { value: null, matchMode: FilterMatchMode.CONTAINS },
  exportador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mercaderia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino: { value: null, matchMode: FilterMatchMode.CONTAINS },
  resultadoProceso: { value: null, matchMode: FilterMatchMode.CONTAINS },
  peso: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
